var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-document-table',{attrs:{"title":_vm.$t('global.models.document.heading'),"subtitle":_vm.$t('global.models.document.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }